import React from "react";
import styled, { css } from "styled-components";
import { Family } from "../api/models/fullProductData.models";

type TypeTagProps = {
  type: Family | null;
  children: React.ReactNode;
};

const StyledTag = styled.span<{ $type: Family | null }>`
  width: 110px;
  text-align: center;
  border: 2px solid #143a6d;
  border-radius: 4px;
  padding: 2px 0;
  font-weight: 500;
  font-size: 14px;
  display: inline-block;
  box-sizing: border-box;
  max-height: 48px;
  margin-top: auto;
  margin-bottom: auto;
  text-align: center;

  ${({ $type }) =>
    $type === "product_model"
      ? css`
          background: none;
          color: #143a6d;
        `
      : $type === "product"
        ? css`
            background: #143a6d;
            color: #fff;
          `
        : css`
            background: var(--sumi-darker-blue);
            border: 2px solid var(--sumi-darker-blue);
            color: var(--sumi-text-primary);
          `}
`;

export const TypeTag: React.FC<TypeTagProps> = ({ type, children }) => (
  <StyledTag $type={type}>{children}</StyledTag>
);
